import { EventItemSimple } from '../event/EventItemSimple';
import EventsList from '../event/EventsList';

const EventsResults = ({ items }) => (
  <EventsList events={items} baseUrl="/search" itemRenderer={EventItemSimple} />
);

export default EventsResults;
